<template>
  <v-data-table :headers="headers" :search="search" :items="desserts" sort-by="created_at" class="elevation-1">
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>users</v-toolbar-title> 
        <v-spacer></v-spacer> 
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Rechercher" single-line hide-details></v-text-field> 
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="800px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">Nouveau User</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                   <v-col cols="12" sm="4" md="4">
                    <v-text-field v-model="editedItem.name" label="Nom"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field v-model="editedItem.email" label="email"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field v-model="editedItem.password" label="Password"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" text @click="close">Annuler</v-btn>
              <v-btn color="green" text @click="save">Valider</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="headline">Êtes-vous sûr de supprimer ?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" text @click="closeDelete">Cancel</v-btn>
              <v-btn color="green" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.benefice`]="{ item }">
        <span v-if="item.benefice >= 0" style="color:green;">{{item.benefice}}</span>
        <span v-if="item.benefice < 0" style="color:red;">{{item.benefice}}</span>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small color="blue" class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
      <!-- <v-icon small color="red" @click="deleteItem(item)">mdi-delete</v-icon> -->
    </template>
  </v-data-table>
</template>



<script>
import axios from 'axios';
  export default {
    data(){
    return {
      search: '',
      dialog: false,
      dialogDelete: false,
      localhost:'https://guide.artnaji.com/index.php/api',
      // localhost:'http://localhost:8000/api',
      headers: [
        { text: 'Nom', value: 'name' },
        {text: 'Email', value: 'email',},
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      desserts: [],
      editedIndex: -1,
      // operation:'dd',
      // editedItem : [],
      editedItem: {
        name: name,
        title: '',
        price: 0,
        wholesaleprice: 0,
        quantity: 0,
      },
      
      defaultItem: {
        name: '',
        title: '',
        price: 0,
        wholesaleprice: 0,
        quantity: 0,
      },
    }
    },

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nouveau user' : 'Modifier user'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      if(!localStorage.getItem('user-token')){
        window.location.href = '../App';
      }
      this.initialize()
    },

    methods: {
      initialize () {
        axios.get(this.localhost+'/users'
        // ,{
        //   headers:{
        //     'Authorization': 'Bearer '+localStorage.getItem('user-token')
        //   }
        // }
        )
        .then(response => {
          console.log(response.data)
          this.desserts = response.data
        })
      },
      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        axios.delete(this.localhost+'/users/'+this.editedItem.id
        // ,{
        //   headers:{
        //     'Authorization': 'Bearer '+localStorage.getItem('user-token')
        //   }
        // }
        ).then(response=>{
            console.log(response)
        })
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
         axios.put(this.localhost+'/users/'+this.editedItem.id,this.editedItem
        //  ,{
        //   headers:{
        //     'Authorization': 'Bearer '+localStorage.getItem('user-token')
        //   }
        // }
        ).then(response=>{
           console.log(response)
           this.initialize()
         })  
        } else {
         axios.post(this.localhost+'/users',this.editedItem
        //  ,{
        //   headers:{
        //     'Authorization': 'Bearer '+localStorage.getItem('user-token')
        //   }
        // }
        ).then(response=>{
           console.log(response)
           this.initialize()
         }) 
        }
        this.close()
      },
    },
  }
</script>